import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input} from '@angular/core';
import {Router} from "@angular/router";
import {animationFrameScheduler} from "rxjs";
import {filter} from "rxjs/operators";

import {CHAR_STRUCT, CHAR_TYPE, OPTION_TYPE, SEUNGJO_DISP_TYPE} from '../../defines/client.const';
import {SASEUNG_DISP_LIST} from '../../defines/gukeo.const';
import {IsEmptyVar} from '../../defines/common.func';
import {SimpleWord} from '../../models/simple-word.model';
import {splitCorrect} from "../../defines/gukeo.func";
import {multiLinkMixin} from "../../mixins/multi-link.mixin";
import {OptionService} from '../../services/option/option.service';
import {DynamicComponentService} from "../../services/dynamic-component/dynamic-component.service";
import {GlobalEventService} from "../../services/global-event/global-event.service";
import {LayoutMgrService} from "../../services/layout-mgr/layout-mgr.service";

@Component({
  selector: 'app-word-disp',
  templateUrl: './word-disp.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WordDispComponent extends multiLinkMixin {
  @Input() word: SimpleWord;
  @Input() select: boolean = false;
  @Input() showLevel: boolean = true

  // TODO: option.showSaseung()을 async 함수로 변환해서 앱 속도를 높일것.
  get showSaseung(): boolean {
    // console.log('showSaseung :', this.option.showSaseung);
    return this.option.showSaseung;
  }

  get seungjoDispType(): SEUNGJO_DISP_TYPE {
    return this.option.seungjoDispType;
  }

  constructor(
    public router: Router,
    public dynamicSvc: DynamicComponentService,
    public lm: LayoutMgrService,
    protected cdRef: ChangeDetectorRef,
    protected option: OptionService,
    protected globalEventSvc: GlobalEventService,
  ) {
    super(router, dynamicSvc, lm);

    this.option.getChange().pipe(
      filter(optionType => optionType === OPTION_TYPE.LARGE_MODE || optionType === OPTION_TYPE.SHOW_SASEUNG)
    ).subscribe(() => {
      animationFrameScheduler.schedule(() => this.cdRef.detectChanges());
    });
  }


  public GetSeungjoClass(cs: CHAR_STRUCT): string {
    if (cs.type === CHAR_TYPE.HANGUL && !IsEmptyVar(cs.seungjo)) {
      return 'word-' + cs.seungjo;
    }
    else if (cs.type === CHAR_TYPE.HANJA && cs.firstHanja) {
      return 'type-spacing';
    }
    else {
      return '';
    }
  }

  // 허용되는 성조
  // TODO: 허용되는 성조가 3일 때에는 표시되는 내용이 없다. 바탕색을 변경해야 하나?
  public GetSeungjoClass2(cs: CHAR_STRUCT): string {
    if (cs.type === CHAR_TYPE.HANGUL && !IsEmptyVar(cs.seungjo2)) {
      return 'word-' + cs.seungjo2;
    }
    else if (cs.type === CHAR_TYPE.HANJA && cs.firstHanja) {
      return 'type-spacing';
    }
    else {
      return '';
    }
  }

  public GetSaseungTxt(cs: CHAR_STRUCT): string {
    // console.log('GetSaseungTxt()', cs);
    return this.showSaseung && cs.type === CHAR_TYPE.HANJA ? SASEUNG_DISP_LIST[cs.saseung] : '';
  }

  public GetCharClass(cs: CHAR_STRUCT): string {
    switch (cs.type) {
      case CHAR_TYPE.HANGUL:
        return 'kor';
      case CHAR_TYPE.HANJA:
        return cs.firstHanja ? 'chn type-spacing' : 'chn';
      case CHAR_TYPE.JANGDAN:
        switch (cs.char) {
          case ':':
            return 'option option1';
          case '/':
            return 'option option2';
          default:
            return 'option';
        }
    }
  }

  public GetCharTxt(cs: CHAR_STRUCT): string {
    return cs.type === CHAR_TYPE.JANGDAN && cs.char === '/' ? '' : cs.char;
  }

  public GetHightlightClass(idx: number): string {
    if (!this.word || !this.word.highlight) {
      return '';
    }

    const highlight = this.word.highlight[idx];
    switch (highlight) {
      case '1':
        return 'highlight';
      case '2':
        return 'highlight2';
      default:
        return '';
    }
  }

  // public playSound(event: Event, url: string): void {
  //   event.stopPropagation();
  //   if (!IsEmptyString(url)) {
  //     this.voice.PlaySound(url).subscribe();
  //   }
  // }

  public get arrowCorrect(): string {
    const [arrow, word] = this.word?.correct ? splitCorrect(this.word?.correct) : [undefined, undefined];
    return arrow ?? '';
  }


  public get wordCorrect(): string | null {
    const [arrow, word] = this.word?.correct ? splitCorrect(this.word?.correct) ?? ['', null] : ['', null];
    return word;
  }


  /**
   * 잘못된 표현의 id를 클릭했을 때, 링크 팝업창이 열리도록 함.
   * @param $event
   */
  onClickCorrect($event: MouseEvent) {
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event, true);

    if (this.word?.correctIds) {
      const ids = this.word.correctIds.join(',');
      this.OpenMultiLink(ids).subscribe(resultLinkPopup => {
        console.warn('OtherRegionDialectComponent.onClick() resultLinkPopup =', resultLinkPopup);
      });
    }
  }

  protected IsHanja(cs: CHAR_STRUCT): boolean {
    return cs.type === CHAR_TYPE.HANJA;
  }
}
